import { StockItemInterface } from '../types/stock';
import { formatDate } from './date';

export const convertJsonForExport = (json: StockItemInterface[]) => {
    const exportJson: Object[] = [];
    const dateFormat = 'dd-MM-yyyy';

    json.map((entry) => {
        const apkDate = entry.apkDate
            ? formatDate(entry.apkDate, dateFormat)
            : '';
        const tachographDate = entry.tachographDate
            ? formatDate(entry.tachographDate, dateFormat)
            : '';
        const examinationFate = entry.examinationDate
            ? formatDate(entry.examinationDate, dateFormat)
            : '';
        const tailgateDate = entry.tailgateDate
            ? formatDate(entry.tailgateDate, dateFormat)
            : '';
        const cfkExaminationDate = entry.cfkExaminationDate
            ? formatDate(entry.cfkExaminationDate, dateFormat)
            : '';

        const newEntry = {
            Vlootnr: entry.stockNumber,
            Kenteken: entry.licensePlate,
            APK: apkDate,
            Tacho: tachographDate,
            Keuring: examinationFate,
            Laadklep: tailgateDate,
            CFK: cfkExaminationDate,
            Voertuig: entry.type.title,
            'Klant notitie': entry.customerNote,
        };

        exportJson.push(newEntry);
    });

    return exportJson;
};
